module.exports = __webpack_public_path__ + "static/media/mortar-board.075128e5.svg";